import { InputProps } from "../components/formComponents/constant/FormComponents";
import { rules } from "../utils/validations/Validations";

export const homeHealthServiceFormProps = [
  {
    label: "Street 1: ",
    name: "serviceAddress.streetName1",
    helper: rules.streetName1,
    textLength: 100,
  },
  {
    label: "Street 2: ",
    name: "serviceAddress.streetName2",
    helper: rules.streetName2,
    textLength: 100,
  },
  {
    label: "City: ",
    name: "serviceAddress.city",
    helper: rules.cityRequired,
    textLength: 100,
  },
  {
    label: "State: ",
    name: "serviceAddress.patientState",
    helper: rules.stateRequired,
    textLength: 100,
  },
  {
    label: "County: ",
    name: "serviceAddress.county",
    helper: rules.physicianCounty,
    textLength: 100,
  },
  {
    label: "Zip Code: ",
    name: "serviceAddress.zipCode",
    helper: rules.physicianZipcode,
    textLength: 10,
  },
  {
    name: "serviceAddress.latitude",
  },
  {
    name: "serviceAddress.longitude",
  },
];

const agencyDetailsLabels: InputProps[] = [
  {
    label: "Agency Name/Branch: ",
    name: "serviceProvider.serviceProviderName",
    textLength: 100,
    helper: {
      optional: null,
      required: rules.agencyBranchName
    } ,
  },
  {
    label: "Agency Email: ",
    name: "serviceProvider.email",
    textLength: 100,
    helper: {
      optional: rules.emailAddressOptional,
      required: rules.emailAddress
    },
  },
  {
    label: "Agency Contact Name: ",
    name: "serviceProvider.contactName",
    textLength: 100,
    helper: {
      optional: null,
      required: rules.agencyContactName
    },
  },
  {
    label: "Agency Phone: ",
    name: "serviceProvider.phone",
    helper: {
      optional: rules.mobilePhone,
      required: rules.phone
    },
    textLength: 100,
    extName: "serviceProvider.extension",
  },
  {
    label: "Agency Fax: ",
    name: "serviceProvider.fax",
    helper: {
      optional: rules.mobilePhone,
      required: rules.sendFax
    },
    textLength: 100,
  },
  {
    label: "Street 1: ",
    name: "serviceProvider.streetName1",
    helper: {
      optional: rules.agencyStreetName1,
      required: rules.agencyStreetName1Required,
    },
    textLength: 100,
  },
  {
    label: "Street 2: ",
    name: "serviceProvider.streetName2",
    helper: {
      optional: rules.streetName2.maxLength,
      required: null,
    },
    textLength: 10,
  },
  {
    label: "City: ",
    name: "serviceProvider.city",
    helper: {
      optional: rules.city,
      required: rules.cityRequired,
    },
    textLength: 100,
  },
  {
    label: "State: ",
    name: "serviceProvider.serviceLocationState",
    helper: {
      optional: rules.state,
      required: rules.stateRequired,
    },
    textLength: 100,
  },
  {
    label: "County: ",
    name: "serviceProvider.county",
    helper: {
      optional: rules.agencyCounty,
      required: null,
    },
    textLength: 100,
  },
  {
    label: "Zip Code: ",
    name: "serviceProvider.zipCode",
    helper: {
      optional: rules.agencyZipCode,
      required: rules.agencyZipCodeRequired,
    },
    textLength: 10,
  },
];

export const agencyDetailsFormProps1 = agencyDetailsLabels.slice(0, 5);
export const agencyDetailsFormProps2 = agencyDetailsLabels.slice(
  5,
  agencyDetailsLabels.length
);

export const ReferralSourceType = {
  Hospital: "2",
  PostAcuteFacility: "3",
};
